/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import { IBotTypeMatcher } from 'generated-types';
import { BotTypeMatcher } from 'object-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

/**
 * @description  BotTypeMatcher ConfigItem class.
 * @author Akul Aggarwal
 */
export class BotTypeMatcherConfigItem extends MessageItem<IBotTypeMatcher> {
    constructor(args = {}) {
        super({
            objectType: BotTypeMatcher,
            ...args,
        });
    }
}
